import { render } from "./EquipmentType.vue?vue&type=template&id=62ec748d"
import script from "./EquipmentType.vue?vue&type=script&lang=js"
export * from "./EquipmentType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__